import { createSlice } from "redux-starter-kit";

const createState = (state, action) => {
  if (!action) return state;
  return { ...state, ...action.payload };
};

const ContentsEdit = createSlice({
  slice: "contents_edit",
  initialState: {
    // contents: [],
    enterContent: false,
    editContent: false,
    editContentIndex: 9999999,
  },
  reducers: {
    initialSet: createState,
    initialEditSet: createState,
    set: createState,
    updateContents: createState,
    uploadContentImage: createState,
    enterContent: createState,
    loadContents: createState,
    loadCourses: createState,
    loadCoursesContents: createState,
    changeFields: createState,
    updateSuccess: createState,
    updateFailure: createState,
    loadSuccess: createState,
    loadFailure: createState,
    uploadContentImageSuccess: createState,
    uploadContentImageFailure: createState,
    loadCoursesSuccess: createState,
    loadCoursesFailure: createState,
    loadCoursesContentsSuccess: createState,
    loadCoursesContentsFailure: createState,
  },
});

export default ContentsEdit;
